export default __webpack_public_path__ + "static/media/card_4.7f96038f.svg";